import { AbstractControl, ValidatorFn } from '@angular/forms';
import { ShellDomainProvider } from '../../core';
import { Injectable } from '@angular/core';
// @dynamic
@Injectable()
export class ValidationService {
    constructor() {}
    public static NumberInWords = {
        '0.1': 'ZERO_POINT_ONE',
        '-99999999': 'NUMBER_MINUS_EIGHT_DIGIT',
        '0': 'NUMBER_ZERO',
        '1': 'NUMBER_ONE',
        '2': 'NUMBER_TWO',
        '3': 'NUMBER_THREE',
        '4': 'NUMBER_FOUR',
        '5': 'NUMBER_FIVE',
        '6': 'NUMBER_SIX',
        '7': 'NUMBER_SEVEN',
        '8': 'NUMBER_EIGHT',
        '9': 'NUMBER_NINE',
        '10': 'NUMBER_TEN',
        '20': 'NUMBER_TWENTY',
        '25': 'NUMBER_TWENTY_FIVE',
        '30': 'NUMBER_THIRTY',
        '40': 'NUMBER_FORTY',
        '50': 'NUMBER_FIFTY',
        '60': 'NUMBER_SIXTY',
        '100': 'NUMBER_ONE_HUNDRED',
        '200': 'NUMBER_TWO_HUNDRED',
        '500': 'NUMBER_FIVE_HUNDRED',
        '99999': 'NUMBER_FIVE_DIGIT',
        '999999': 'NUMBER_SIX_DIGIT',
        '99999999': 'NUMBER_EIGHT_DIGIT'
    };
    public static cnt = 0;

    static getValidatorErrorMessage(validatorName: string, validatorValue?: any) {
        let config = {
            required: 'ERR_MSG_REQUIRED',
            invalidEmailAddress: 'ERR_MSG_EMAIL',
            partnerNameCantnotbeOther: 'ERR_MSG_PARTNER_NAME_CAN_NOT_BE_OTHER',
            invalidPassword: 'ERR_MSG_INVALID_PASSWORD',
            minlength:
                'ERR_MSG_MIN_LENGTH_' +
                ValidationService.getNumberInWords(
                    validatorValue && !isNaN(validatorValue.requiredLength) ? validatorValue.requiredLength : 0
                ),
            maxlength:
                'ERR_MSG_MAX_LENGTH_' +
                ValidationService.getNumberInWords(
                    validatorValue && !isNaN(validatorValue.requiredLength) ? validatorValue.requiredLength : 0
                ),
            min:
                'ERR_MSG_MINIMUM_VALUE_' +
                ValidationService.getNumberInWords(
                    validatorValue && !isNaN(validatorValue.min) ? validatorValue.min : 0
                ),
            max:
                'ERR_MSG_MAXIMUM_VALUE_' +
                ValidationService.getNumberInWords(
                    validatorValue && !isNaN(validatorValue.max) ? validatorValue.max : 0
                ),
            invalidLoanAmount: 'ERR_MSG_LOAN_AMOUNT',
            invalidZipCode: 'ERR_MSG_INVALID_ZIPCODE',
            invalidInterestRate: 'ERR_MSG_INVALID_INTEREST_RATE',
            optionSelectedFromAutoComplete: 'ERR_MSG_AUTOCOMPLETE',
            savingsAmountValidator: 'ERR_MSG_VALUE_DEPENDS_ON_AMOUNT',
            incomeAmountNotValid: 'ERR_MSG_INCOME_AMOUNT',
            invalidUrl: 'ERR_MSG_SITE_URL',
            invalidinteger: 'ERR_MSG_INVALID_INTEGER',
            duplicatePhoneNumber: 'PHONE_NUMBER_ALREADY_EXISTS',
            duplicateEmail: 'EMAIL_ID_ALREADY_EXISTS',
            duplicateId: 'CUSTOMER_ID_ALREADY_EXISTS',
            invalidEndDate: 'END_DATE_CAN_NOT_BE_LESS_THEN_START_DATE',
            invalidStartDate: 'START_DATE_CAN_NOT_BE_MORE_THEN_END_DATE',
            invalidDate: 'INVALID_DATE_FORMAT',
            dateGreaterThanToday: 'DATE_CAN_NOT_BE_GREATER_THAN_TODAY',
            invalidPhoneNumber: 'ERR_MSG_PHONE_NUM',
            matDatepickerParse: 'INVALID_DATE_FORMAT',
            contractNumberDuplicate: 'CONTRACT_NUMBER_DUPLICATE',
            invalidPositiveNumber: 'ERR_MSG_POSITIVE_AMOUNT',
            invalidTargetDate: 'TARGET_DATE_CAN_NOT_LESS_THEN_BIRTH_DATE',
            minGreaterThanMax: 'MIN_GREATER_THAN_MAX_ERROR',
            forbiddenCharacterPresent: 'FILE_NAME_CANT_CONTAIN'
        };

        return config[validatorName];
    }

    static getNumberInWords(number: number) {
        if (!isNaN(number)) {
            return ValidationService.NumberInWords[number.toString()];
        } else null;
    }

    // Fallback when the host sets no ShellDomainProvider['api']['EmailValidatorRegex'].
    // Keep identical to EMAIL_VALIDATOR_REGEX in environment.commonConfigurations.ts.
    static readonly DEFAULT_EMAIL_REGEX =
        '^[_a-z0-9A-Z+-]+(\\.[_a-zA-Z0-9+-]+)*@[_a-z0-9A-Z-]+(\\.[_a-zA-Z0-9-]+)*(\\.[a-zA-Z]{2,})$';

    static getEmailRegex(): RegExp {
        const validatingRegex = ShellDomainProvider['api']['EmailValidatorRegex']
            ? ShellDomainProvider['api']['EmailValidatorRegex']
            : ValidationService.DEFAULT_EMAIL_REGEX;
        return new RegExp(validatingRegex);
    }

    static isValidEmail(value: string): boolean {
        return !!value && !!value.match(ValidationService.getEmailRegex());
    }

    static emailValidator(control) {
        if (control.value && control.value.match(ValidationService.getEmailRegex())) {
            return null;
        } else if (!control.value) {
            return null;
        } else {
            return { invalidEmailAddress: true };
        }
    }

    static PartnerNameValidator(control) {
        let validator = 'other';
        if (control.value && control.value.toLowerCase().match(validator)) {
            return { partnerNameCantnotbeOther: true };
        } else if (!control.value) {
            return null;
        } else {
            return null;
        }
    }

    static phoneNumerValidator(control) {
        // control.value && control.value.match(/^[+]?\d+[-]?\d+$/)
        if (control.value && control.value.match(/^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/)) {
            return null;
        } else if (!control.value) {
            return null;
        } else {
            return { invalidPhoneNumber: true };
        }
    }

    static passwordValidator(control) {
        // {6,36}           - Assert password is between 6 and 36 characters
        // (?=.*[0-9])       - Assert a string has at least one number
        if (control.value.match(/^(?=.*[0-9])[a-zA-Z0-9!@#$%^&*)(}{\]\[\?><\/\\`~\-_=+]{6,36}$/)) {
            return null;
        } else {
            return { invalidPassword: true };
        }
    }

    static zipCodeValidator(control) {
        if (control.value) {
            if (control.value.match(/^\+?([0-9]{2})\)?[-. ]?([0-9]{4})[-. ]?([0-9]{4})$/)) {
                return null;
            } else {
                return { invalidZipCode: true };
            }
        }
        return null;
    }

    static urlValidator(control) {
        if (control.value) {
            if (
                control.value.match(
                    /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-zA-Z0-9]+([\-\.]{1}[a-zA-Z0-9]+)*\.[a-zA-Z]{2,5}(:[0-9]{1,5})?(\/.*)?$/
                )
            ) {
                return null;
            } else {
                return { invalidUrl: true };
            }
        } else {
            return null;
        }
    }

    static loanAmountValidator(control) {
        if (control.value) {
            if (String(control.value).match(/^[1-9]\d*$/)) {
                return null;
            } else {
                return { invalidLoanAmount: true };
            }
        }
        return null;
    }

    static positiveNumberValidator(control) {
        if (control.value > 0) {
            return null;
        } else {
            return { invalidPositiveNumber: true };
        }
    }

    static interestnRateValidator(control) {
        if (control.value) {
            if (String(control.value).match(/^(\d*\.)?[0-9]{1,2}$/)) {
                return null;
            } else {
                return { invalidInterestRate: true };
            }
        }
        return null;
    }

    static integerValidator(control) {
        if (control.value) {
            if (String(control.value).match(/^[1-9]\d*$/)) {
                return null;
            } else {
                return { invalidinteger: true };
            }
        }
        return null;
    }

    static autoCompleteSearchValidator(isSelected: boolean): ValidatorFn {
        return (control: AbstractControl): { [key: string]: boolean } | null => {
            if (control.value !== undefined && isSelected == false) {
                return { optionSelectedFromAutoComplete: true };
            }
            return null;
        };
    }

    static savingsAmountValidator(isValid: boolean, max: number): ValidatorFn {
        return (control: AbstractControl): { [key: string]: boolean } | null => {
            if (control.value !== undefined) {
                if (isValid == true) {
                    if (control.value >= max) {
                        return { savingsAmountValidator: true };
                    } else {
                        return null;
                    }
                } else {
                    return { incomeAmountNotValid: true };
                }
            }
            return null;
        };
    }

    static resetServerError(form: any, errors?: any) {
        if (errors) {
            for (let i in errors) {
                if (form.controls[errors[i]['PropertyName']]) {
                    form.get(errors[i]['PropertyName'])['serverErrors'] = [];
                }
            }
        } else {
            for (let i in form.controls) {
                form.controls[i]['serverErrors'] = [];
            }
        }
        return form;
    }

    static dateValidator(control) {
        let dateValue;

        if (control.value) {
            let moment = require('moment');
            if (moment.isMoment(control.value)) {
                dateValue = control.value._i;
                if (typeof dateValue === 'object') {
                    dateValue = dateValue.date + '/' + (dateValue.month + 1) + '/' + dateValue.year;
                }
            } else {
                // after loan is fixed it will be gone
                dateValue = ValidationService.getDateFormatDMY(control.value);
            }
            if (
                String(dateValue)
                    .trim()
                    .match(
                        /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[1,3-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/
                    )
            ) {
                return null;
            } else {
                return { invalidDate: true };
            }
        }
        return null;
    }

    static getDateFormatDMY(date): any {
        let moment = require('moment');
        let dateValue;
        if (moment.isMoment(date)) {
            dateValue = moment(date).format('DD/MM/YYYY');
        } else if (date instanceof Date) {
            dateValue = date.getDate() + '/' + (date.getMonth() + 1) + '/' + date.getFullYear();
        } else {
            let dateObject = new Date(date.trim());
            dateValue = dateObject.getDate() + '/' + (dateObject.getMonth() + 1) + '/' + dateObject.getFullYear();
        }
        return dateValue;
    }

    static getDateTime(date): any {
        // let moment, dateTime, dateString, splitChar, dateParts, dateObject;
        // moment = require('moment');
        // if (moment.isMoment(date)) {
        // 	dateString = date._i;
        // 	if (dateString.indexOf('.') > 0) {
        // 	    splitChar = '.';
        // 	} else if (dateString.indexOf('/') > 0) {
        // 	    splitChar = '/';
        // 	} else if (dateString.indexOf('-') > 0) {
        // 	    splitChar = '-';
        // 	}
        // 	dateParts = dateString.split(splitChar);
        // 	if (dateParts.length === 3) {
        // 		dateObject = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]);
        // 		dateString = dateObject.getDate() + '/' + (dateObject.getMonth() + 1) + '/' + dateObject.getFullYear();
        // 	}
        // 	dateTime = date._d.getTime();
        // } else if (date instanceof Date) {
        // 	dateTime = date.getTime();
        // } else if (typeof (date) === 'string') {
        // 	dateTime = new Date(date).getTime();
        // }

        if (date) {
            let dateTime;
            let dateParts = date.split('/');
            if (dateParts.length === 3) {
                let dateObject = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]);
                dateTime = dateObject.getTime();
            }
            return dateTime;
        }
    }

    static dateNotMoreThanTodayValidator(control) {
        if (control.value) {
            let dateValue, today, dateDMY;
            dateDMY = ValidationService.getDateFormatDMY(control.value);
            dateValue = ValidationService.getDateTime(dateDMY);
            today = new Date().getTime();
            if (dateValue <= today) {
                return null;
            } else {
                return { dateGreaterThanToday: true };
            }
        }
        return null;
    }

    //
    static endDateValidator(control) {
        if (control.value && control.startDateValue) {
            let startDateString, endDateString;
            let startDateDMY, endDateDMY;

            startDateDMY = ValidationService.getDateFormatDMY(control.startDateValue);
            endDateDMY = ValidationService.getDateFormatDMY(control.value);

            if (
                String(startDateDMY).match(
                    /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[1,3-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/
                ) &&
                String(endDateDMY).match(
                    /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[1,3-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/
                )
            ) {
                startDateString = ValidationService.getDateTime(startDateDMY);
                endDateString = ValidationService.getDateTime(endDateDMY);
                if (endDateString < startDateString) {
                    return { invalidEndDate: true };
                } else {
                    return null;
                }
            }
        }
        return null;
    }

    //
    static startDateValidator(control) {
        if (control.value && control.endDateValue) {
            let startDateString, endDateString;
            let startDateDMY, endDateDMY;

            endDateDMY = ValidationService.getDateFormatDMY(control.endDateValue);
            startDateDMY = ValidationService.getDateFormatDMY(control.value);

            if (
                String(startDateDMY).match(
                    /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[1,3-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/
                ) &&
                String(endDateDMY).match(
                    /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[1,3-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/
                )
            ) {
                startDateString = ValidationService.getDateTime(startDateDMY);
                endDateString = ValidationService.getDateTime(endDateDMY);

                if (startDateString > endDateString) {
                    return { invalidStartDate: true };
                } else {
                    return null;
                }
            }
        }
        // ^([0-2][0-9]|(3)[0-1])(\/)(((0)[0-9])|((1)[0-2]))(\/)\d{4}$
        // ^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[1,3-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$
        // ^((0?[13578]|10|12)(-|\/)(([1-9])|(0[1-9])|([12])([0-9]?)|(3[01]?))(-|\/)((19)([2-9])(\d{1})|(20)([01])(\d{1})|([8901])(\d{1}))|(0?[2469]|11)(-|\/)(([1-9])|(0[1-9])|([12])([0-9]?)|(3[0]?))(-|\/)((19)([2-9])(\d{1})|(20)([01])(\d{1})|([8901])(\d{1})))$

        return null;
    }

    static getValidatedForm(form: any, errors: any): any {
        form = ValidationService.resetServerError(form, errors);
        for (let i in errors) {
            if (form.controls[errors[i]['PropertyName']] && errors[i]['ErrorMessage']) {
                if (form.get(errors[i]['PropertyName'])['serverErrors']) {
                    form.get(errors[i]['PropertyName'])['serverErrors'].push(errors[i]['ErrorMessage']);
                } else {
                    form.get(errors[i]['PropertyName'])['serverErrors'] = [errors[i]['ErrorMessage']];
                }
            }
        }
        return form;
    }

    static targetDateValidator(control) {
        if (control.value && control.customerDateOfBirth) {
            let customerBirthDateString, targetDateString;
            let customerBirthDateDMY, targetDateDMY;

            customerBirthDateDMY = ValidationService.getDateFormatDMY(control.customerDateOfBirth);
            targetDateDMY = ValidationService.getDateFormatDMY(control.value);

            if (
                String(customerBirthDateDMY).match(
                    /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[1,3-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/
                ) &&
                String(targetDateDMY).match(
                    /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[1,3-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/
                )
            ) {
                customerBirthDateString = ValidationService.getDateTime(customerBirthDateDMY);
                targetDateString = ValidationService.getDateTime(targetDateDMY);
                if (targetDateString < customerBirthDateString) {
                    return { invalidTargetDate: true };
                } else {
                    return null;
                }
            }
        }
        return null;
    }

    static forbiddenCharacterValidator(control) {
        const forbiddenStr = '!@#$%^&*()+:"{}|[]<>?/~`.,\\';
        let forbiddenChars: string[] = [];
        for (let i = 0; i < forbiddenStr.length; i++) {
            forbiddenChars.push(forbiddenStr[i]);
        }

        if (control.value) {
            let forbiddenCharPresent = false;
            forbiddenChars.map(char => {
                if (control.value.indexOf(char) > -1) {
                    forbiddenCharPresent = true;
                }
            });
            if (forbiddenCharPresent) {
                return { forbiddenCharacterPresent: true };
            } else {
                return null;
            }
        } else {
            return null;
        }
    }
}
